import { GetProductCategoryResponseType } from 'features/Enterprise/ReorderList/services/reorderList'
import { ProductType } from 'features/Product/@types/Product'
import { type LocationType } from 'utils/apiList/dynamicChannel'
import { type ImageVariantIdType, type ImageRulesType } from 'utils/apiList/images'
import { BannerType } from 'features/CategoryAndPosisi/@types/dynamicChannel'
import { DndDataType } from 'features/CategoryAndPosisi/@types/CatalogueAddEdit'
import { GetAllSegmentsResponseType } from 'features/BannerAndTicker/sevices/banner'

export { type GetAllSegmentsResponseType }

export enum ProductHighlightLabelEnum {
  HEMAT = 1,
  FREE_TEXT = 2,
}

export type SelectedBannerType = {
  fe_unique_id: string
} & BannerType

export type SelectedBannerSlotsStateType = SelectedBannerType[][]

export type HandleChangeSelectedBannerSlotsType = (
  slotNumber: number,
  newSelectedBannerList: SelectedBannerType[],
) => void

export type BannerSectionPropsType = {
  selectedBannerSlots: SelectedBannerSlotsStateType
  handleChangeSelectedBannerSlots: HandleChangeSelectedBannerSlotsType
}

export type DynamicChannelBackgroundColorsType =
  | 'merah'
  | 'orange'
  | 'hijau'
  | 'biru'
  | 'kuning'
  | 'ungu'

export type DynamicChannelBackgroundColorOptionType = {
  color: string
  value: DynamicChannelBackgroundColorsType
  name: string
}

export type ImageConfigType = {
  url_large: string
  url_medium: string
  url_small: string
}

export type BannerHighlightType = {
  id: number
  category_id: number
  position: number
  hubs: LocationType[]
  start_date: number
  end_date: number
  banner_category_highlight_image: Nullable<ImageConfigType>
  is_active: boolean
  is_deleted: boolean
}

export type ProductHighlightType = {
  id: number
  product_id: number
  position: number
  hubs: LocationType[]
  start_date: number
  end_date: number
  free_text: string
  default_text: string
  is_active: boolean
}

export type ProductCategoryType = GetProductCategoryResponseType['content'][number]

export type BannerHighlightFormType = {
  id?: number
  is_active: boolean
  is_deleted: boolean
  imageFile: Nullable<File>
  imagePreview: string
  startDate: string
  startTime: string
  endDate: string
  endTime: string
  category: Nullable<ProductCategoryType>
  hubs: LocationType[]
}

export type BannerHighlightListType = BannerHighlightFormType &
  Partial<Pick<BannerHighlightType, 'banner_category_highlight_image'>> & { uniqueKey: string }

export type ProductHighlightLabelType = {
  id: ProductHighlightLabelEnum
  name: string
}

export type ProductHighlightFormType = {
  id?: number
  is_active: boolean
  is_deleted: boolean
  startDate: string
  startTime: string
  endDate: string
  endTime: string
  hubs: LocationType[]
  default_text: string
  free_text: string
  labelType: Nullable<ProductHighlightLabelType>
  product: Nullable<ProductType>
}

export type ProductHighlightListType = ProductHighlightFormType & { uniqueKey: string }

export type DynamicChannelTargetingType = {
  browse_segmentations: number[]
  dynamic_channel_id: number
  targeting_type_id: number
  targeted_users: number[]
}

export type DynamicChannelFormType = {
  category: Nullable<ProductCategoryType>
  bgColor: Nullable<DynamicChannelBackgroundColorOptionType>
  hubs: LocationType[]
  startDate: string
  startTime: string
  endDate: string
  endTime: string
}

export type DialogType = {
  mode: '' | 'BANNER_2X2'
  index2x2: number
  dndData: DndDataType[]
}

export type InitialStateType = {
  form: DynamicChannelFormType
  bannerHighlight: {
    isFormShow: boolean
    selectedBanner: Nullable<BannerHighlightListType>
    form: BannerHighlightFormType
    list: BannerHighlightListType[]
    categories: ProductCategoryType[]
  }
  productHighlight: {
    isFormShow: boolean
    selectedProduct: Nullable<ProductHighlightListType>
    form: ProductHighlightFormType
    list: ProductHighlightListType[]
    products: ProductType[]
  }
  imageRules: Record<ImageVariantIdType, ImageRulesType> | ObjectNullType
  targetingType: DynamicChannelTargetingType
  dialog: DialogType
  segmentOptions: GetAllSegmentsResponseType
}

export type SetBannerHighlightFormPayloadActionType = {
  field: keyof BannerHighlightFormType
  value: BannerHighlightFormType[keyof BannerHighlightFormType]
}

export type SetProductHighlightFormPayloadActionType = {
  field: keyof ProductHighlightFormType
  value: ProductHighlightFormType[keyof ProductHighlightFormType]
}

export type SetProductHighlightProductsPayloadActionType = ProductType[]

export type SetFormPayloadActionType = {
  field: keyof DynamicChannelFormType
  value: DynamicChannelFormType[keyof DynamicChannelFormType]
}

export type SetDialogPayloadActionType = Partial<DialogType>

export type PostPutDynamicChannelPayloadType = {
  banners: {
    banner_id: number
    id: number
    position: number
    slot: number
  }[]
  banners_highlight: {
    category_id: number
    end_date: number
    highlight_image: {
      category_highlight_id: Nullable<number>
      id: Nullable<number>
      url_large: string
      url_medium: string
      url_small: string
    }
    id: number
    is_active: boolean
    is_deleted: boolean
    location_ids: number[]
    position: number
    start_date: number
  }[]
  bg_color: string
  catalogue_id: Nullable<number>
  catalogue_ids: number[]
  category_id: Nullable<number>
  category_ids: number[]
  start_date: number | string
  end_date: number | string
  dynamic_channel_section_id: Nullable<number>
  dynamic_channel_targeting_type: {
    targeted_segmentations: {
      segment_type_id: number
    }[]
    targeted_user_ids: number[]
    targeting_type: number
  }
  dynamic_channel_type_id: number
  hubs: number[]
  image_url: string
  is_active: boolean
  is_product_tabbing: boolean
  logic_id: Nullable<number>
  products_highlight: {
    default_text: string
    end_date: number
    free_text: string
    id: number
    is_active: boolean
    is_deleted: boolean
    label_type: number
    location_ids: number[]
    position: number
    product_id: number
    start_date: number
  }[]
  title: string
}
